'use client'

import React, { useState, forwardRef, ForwardedRef } from 'react'
import classNames from 'classnames'

import { TextfieldProps } from './Textfield.schema'

import Icon from '@/icon/Icon'

const Textfield = forwardRef<HTMLInputElement, TextfieldProps>((props: TextfieldProps, ref?: ForwardedRef<HTMLInputElement>) => {
    const [value, setValue] = useState(props.value || '')

    const isControlled = props.onChange && props.value !== undefined
    const dynamicValue = isControlled ? props.value : value

    const type = props.type || 'text'

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (props.isNumeric && isNaN(Number(event.target.value))) {
            return
        }

        if (!isControlled) {
            setValue(event.target.value)
        }

        if (props.onChange) {
            props.onChange(event)
        }
    }

    const className = classNames(
        'textfield',
        props.className,
        {
            'is-invalid': props.isInvalid,
            'has-value': dynamicValue && dynamicValue.length > 0,
            'has-icon': props.icon || props.isInvalid,
            'textfield--flat-top': props.flatTop,
            'textfield--flat-bottom': props.flatBottom,
        }
    )

    const inputСlassName = classNames('textfield__input', {
        'with-button': props.inputContent,
        'is-readonly': props.readOnly
    })

    const labelClassName = classNames('textfield__label', { 'has-placeholder': !!props.placeholder })

    return (
        <div className={className}>
            <label className='textfield__inner'>
                <input
                    ref={ref}
                    className={inputСlassName}
                    type={type}
                    name={props.name ? props.name : undefined}
                    value={dynamicValue}
                    onChange={handleInputChange}
                    readOnly={props.readOnly}
                    placeholder={props.placeholder}
                    maxLength={props.maxLength}
                />
                <span className={labelClassName}>{props.label}</span>
                {props.inputContent}
                {(props.icon || props.isInvalid) && (
                    <Icon className='textfield__icon' name={props.isInvalid ? 'error' : props.icon as string} />
                )}
            </label>
            {props.description && (
                <p className='textfield__description'>{props.description}</p>
            )}
        </div>
    )
})

Textfield.displayName = 'Textfield'

export default Textfield
